export enum BENEFIT_GROUP_CATEGORY {
  FAMILIES = 'families',
  CHRONIC_CONDITIONS = 'chronicConditions',
  FERTILITY_CARE = 'fertilityCare',
}

export enum BENEFIT_ID {
  GOOGLE_PERFORMANCE = 'googlePerformance',
  LYRA_RESOURCE_COORDINATION = 'lyraResourceCoordination',
  CARELON = 'carelon-logo-png_seeklogo-494119',
  PENN_MEDICINE = 'penn-medicine-logo-png_seeklogo-187624',
  // Salesforce provides this case-sensitive benefit name as the identifier.
  COBALT = 'Cobalt',
}

export enum BENEFITS_SECTION_ID {
  FEATURED = 'Featured',
  CORE_BENEFITS = 'CoreBenefits',
  WORKPLACE_BENEFITS = 'WorkplaceBenefits',
  SPECIALIZED_CARE = 'SpecializedCare',
  CURATED_FOR_YOU = 'CuratedForYou',
  MORE_BENEFITS = 'MoreBenefits',
}

export const LYRA_HUB_LINK = 'https://app.icas.health'
export const LYRA_ESSENTIALS_BENEFIT = 'Lyra Essentials'

export const UPHS_CARELON_BENEFIT_URL = 'https://www.carelonbh.com/uphs/en/home'
